import type { ColumnDef } from "@tanstack/react-table";

// Icons
import { ArrowUpDown } from "lucide-react";

// UI
import { Button } from "@/components/ui/button";

// Icons
import { Eye } from "lucide-react";

// Types
import type { Law } from "@/types/law";
import formatDate from "@/utils/formatDate";
import { SOE_PREVIEW_URL } from "@/components/constants";

export const columns = (isDownload: boolean): ColumnDef<Law>[] => [
  {
    id: "no",
    accessorFn: (_, index) => index + 1,
    // header: ({ column }) => {
    // 	return (
    // 		<Button

    // 			onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
    // 		>
    // 			ລຳດັບ
    // 			<ArrowUpDown className="w-4 h-4 ml-2" />
    // 		</Button>
    // 	);
    // },
    header: "ລຳດັບ",
    cell: (info) => info.row.index + 1,
  },
  {
    accessorKey: "name",
    header: "ຊື່ກົດໝາຍ ແລະ ນິຕິກຳ",
    cell: ({ row }) => {
      const data = row.original;
      return (
        <p className="flex items-center gap-2">
          <Eye className="text-blue-500" /> {data?.name}
        </p>
      );
    },
  },
  {
    header: "ປະເພດຂອງແຈ້ງການ",
    cell: ({ row }) => {
      const data = row.original;

      return <p>{data?.lawType?.name} </p>;
    },
  },
  {
    id: "link",
    header: "ລິ້ງເອກະສານ",
    cell: ({ row }) => {
      const data = row.original;

      return (
        isDownload && (
          <a
            target="_blank"
            rel="noreferrer"
            className="text-blue-500 underline"
            href={(SOE_PREVIEW_URL + data?.fileUrl) as string}
          >
            ເບິ່ງເອກະສານ
          </a>
        )
      );
    },
  },
  {
    accessorKey: "updatedAt",
    header: ({ column }) => {
      return (
        <Button
          variant={"ghost"}
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ອັບເດດລ່າສຸດ
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      );
    },
    cell: ({ row }) => {
      const data = row.original;

      return (
        <p>
          {formatDate({
            date: data?.updatedAt,
            format: "DD/MM/YYYY",
          })}
        </p>
      );
    },
  },
  // {
  // 	header: "ອັບເດດໂດຍ",
  // 	cell: ({ row }) => {
  // 		const data = row.original;

  // 		return <p>{data?.updatedBy}</p>;
  // 	},
  // },

  // {
  // 	id: "actions",
  // 	cell: ({ row }) => {
  // 		const data = row.original;

  // 		const navigate = useNavigate();

  // 		return (
  // 			<Button
  // 				variant="outline"
  // 				className="z-10 w-8 h-8 p-0"
  // 				onClick={() => {
  // 					navigate({
  // 						to: "/law/mutate",
  // 						search: {
  // 							id: data.id,
  // 							data: JSON.stringify(data),
  // 						},
  // 					});
  // 					console.log(data.id);
  // 				}}
  // 			>
  // 				<Pencil className="w-4 h-4" />
  // 			</Button>
  // 		);
  // 	},
  // },
];
